import { render, staticRenderFns } from "./questionnaireRadio.vue?vue&type=template&id=2513dc3d&scoped=true&"
import script from "./questionnaireRadio.vue?vue&type=script&lang=js&"
export * from "./questionnaireRadio.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireRadio.vue?vue&type=style&index=0&id=2513dc3d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2513dc3d",
  null
  
)

export default component.exports